import coreTokens from '@woolworthslimited/core-tokens/dist/shared/json/tokens.json';

const {
  breakpoint: {
    xxs: breakpointXxs,
    xs: breakpointXs,
    sm: breakpointSm,
    md: breakpointMd,
    lg: breakpointLg,
    xl: breakpointXl,
    xxl: breakpointXxl,
  },
} = coreTokens;

export const SCREEN_XXS_MIN = breakpointXxs;
export const SCREEN_XS_MIN = breakpointXs;
export const SCREEN_SM_MIN = breakpointSm;
export const SCREEN_MD_MIN = breakpointMd;
export const SCREEN_LG_MIN = breakpointLg;
export const SCREEN_XL_MIN = breakpointXl;
export const SCREEN_XXL_MIN = breakpointXxl;

// Screen Maxes
export const SCREEN_XS_MAX = SCREEN_SM_MIN - 1;
export const SCREEN_SM_MAX = SCREEN_MD_MIN - 1;
export const SCREEN_MD_MAX = SCREEN_LG_MIN - 1;

export type BreakpointSize =
  | typeof SCREEN_XXS_MIN
  | typeof SCREEN_XS_MIN
  | typeof SCREEN_SM_MIN
  | typeof SCREEN_MD_MIN
  | typeof SCREEN_LG_MIN
  | typeof SCREEN_XL_MIN
  | typeof SCREEN_XXL_MIN;
